module.exports = __webpack_public_path__ + "static/img/case_tab_10.502ec59.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/case/case_tab_10.png
// module id = Q/lH
// module chunks = 34